import React from "react";
import DayAndHourSelector from "../../DayAndHourSelector/DayAndHourSelector";
import MeetingTimes from "../../../Data/MeetingTimes";
import TimeSlotDeleteButton from "../TimeSlotDeleteButton/TimeSlotDeleteButton";

class TimeSlot extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      daysValue: "",
      hoursValue: "",
      fullDays: [],
      checkedDays: [],
      checkedHours: [],
      days: [],
      hours: [],
    };

    this.pullDaysData = this.pullDaysData.bind(this);
    this.pullHoursData = this.pullHoursData.bind(this);
    this.handleDayCheckboxClick = this.handleDayCheckboxClick.bind(this);
    this.handleHourCheckboxClick = this.handleHourCheckboxClick.bind(this);
    this.handleDayCheckboxOnChange = this.handleDayCheckboxOnChange.bind(this);
    this.handleHourCheckboxOnChange = this.handleHourCheckboxOnChange.bind(
      this
    );
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleDeleteTimeSlot = this.handleDeleteTimeSlot.bind(this);
  }

  componentDidMount() {
    if (this.props.selectedDays && this.props.selectedHours) {
      this.pullDaysData([...this.props.selectedDays]);
      this.pullHoursData([...this.props.selectedHours]);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.selectedDays !== prevProps.selectedDays &&
      this.props.selectedHours !== prevProps.selectedHours
    ) {
      if (this.props.selectedDays && this.props.selectedHours) {
        this.pullDaysData([...this.props.selectedDays]);
        this.pullHoursData([...this.props.selectedHours]);
      }
    }
  }

  pullDaysData(selectedDaysArray) {
    let checkedDays = [...selectedDaysArray];
    if (checkedDays === ["Weekdays"]) {
      this.setState({
        daysValue: "Weekdays",
        checkedDays: checkedDays,
        fullDays: MeetingTimes.days.map((d) => {
          return d.value;
        }),
        days: MeetingTimes.days.map((d) => {
          return {
            id: d.id,
            value: d.value,
            short: d.short,
            isChecked: true,
          };
        }),
      });
    } else if (checkedDays === []) {
      this.setState({
        daysValue: "",
        checkedDays: checkedDays,
        fullDays: [],
        days: MeetingTimes.days.map((d) => {
          return {
            id: d.id,
            value: d.value,
            short: d.short,
            isChecked: false,
          };
        }),
      });
    } else {
      let valuesArray = [];
      let value = "";
      let newDays = [];
      MeetingTimes.days.forEach((d) => {
        let result = checkedDays.find((v) => v === d.value);
        if (result) {
          valuesArray.push(d.short);
          newDays.push({
            id: d.id,
            value: d.value,
            short: d.short,
            isChecked: true,
          });
        } else {
          newDays.push({
            id: d.id,
            value: d.value,
            short: d.short,
            isChecked: false,
          });
        }
      });
      value = valuesArray.join(", ");
      this.setState({
        daysValue: value,
        checkedDays: checkedDays,
        fullDays: checkedDays,
        days: newDays,
      });
    }
  }

  pullHoursData(selectedHoursArray) {
    let checkedHours = selectedHoursArray;
    if (checkedHours === []) {
      this.setState({
        hoursValue: "",
        checkedHours: checkedHours,
        hours: MeetingTimes.hours.map((d) => {
          return {
            id: d.id,
            value: d.value,
            isChecked: false,
          };
        }),
      });
    } else {
      let valuesArray = [];
      let value = "";
      let newHours = [];
      MeetingTimes.hours.forEach((d) => {
        let result = checkedHours.find((v) => v === d.value);
        if (result) {
          valuesArray.push(d.value);
          newHours.push({
            id: d.id,
            value: d.value,
            isChecked: true,
          });
        } else {
          newHours.push({
            id: d.id,
            value: d.value,
            isChecked: false,
          });
        }
      });
      value = valuesArray.join(", ");
      this.setState({
        hoursValue: value,
        checkedHours: checkedHours,
        hours: newHours,
      });
    }
  }

  /**
   * Handles when user clicks the checkbox
   * @param {String} value
   */
  handleDayCheckboxClick(value) {
    let fullDays = [];
    let valueArray = [];
    let stringValue = "";
    //Get all days based on state
    let days = [...this.state.days];
    //Get the day
    let day = days.find((d) => d.value === value);
    //If day exists
    //Clicked day is Weekdays
    if (day.value === "Weekdays") {
      if (day.isChecked === true) {
        //Empty selections
        this.setState({
          daysValue: "",
          checkedDays: [],
          fullDays: fullDays,
          days: MeetingTimes.days.map((d) => {
            return {
              id: d.id,
              value: d.value,
              short: d.short,
              isChecked: false,
            };
          }),
        });
      } else {
        //Select all
        fullDays = days.map((d) => {
          return d.value;
        });
        this.setState({
          daysValue: "Weekdays",
          checkedDays: ["Weekdays"],
          fullDays: fullDays,
          days: MeetingTimes.days.map((d) => {
            return {
              id: d.id,
              value: d.value,
              short: d.short,
              isChecked: true,
            };
          }),
        });
      }
      //Selected day is not 'Weekdays' but 'Weekdays is checked
    } else if (day.value !== "Weekdays" && days[0].isChecked === true) {
      //If day is currently checked and is going to get unchecked
      if (day.isChecked === true) {
        //Get all days except current day and weekdays
        days.forEach((d) => {
          if (d.value !== day.value && d.value !== "Weekdays") {
            fullDays.push(d.value);
          }
        });

        MeetingTimes.days.forEach((d) => {
          fullDays.forEach((v) => {
            if (d.value === v) {
              valueArray.push(d.short);
            }
          });
        });
        stringValue = valueArray.join(", ");

        this.setState({
          daysValue: stringValue,
          checkedDays: fullDays,
          fullDays: fullDays,
          days: MeetingTimes.days.map((d) => {
            let result = fullDays.find((v) => v === d.value);
            if (result) {
              return {
                id: d.id,
                value: d.value,
                short: d.short,
                isChecked: true,
              };
            } else {
              return {
                id: d.id,
                value: d.value,
                short: d.short,
                isChecked: false,
              };
            }
          }),
        });
      }
      //If day is currently not checked and is going to get checked
      // else is useless as there is no option not checked if Weekdays is checked
    } else {
      //Now Weekdays is not active
      let selectedDays = [];
      days.forEach((d) => {
        if (d.isChecked === true && d.value !== "Weekdays") {
          selectedDays.push(d.value);
        }
      });

      //If day is currently checked and is going to be unchecked
      if (day.isChecked === true) {
        selectedDays.forEach((d) => {
          if (d !== day.value) {
            fullDays.push(d);
          }
        });

        MeetingTimes.days.forEach((d) => {
          let result = fullDays.find((v) => v === d.value);
          if (result) {
            valueArray.push(d.short);
          }
        });
        stringValue = valueArray.join(", ");

        this.setState({
          daysValue: stringValue,
          checkedDays: fullDays,
          fullDays: fullDays,
          days: MeetingTimes.days.map((d) => {
            let result = fullDays.find((v) => v === d.value);
            if (result) {
              return {
                id: d.id,
                value: d.value,
                short: d.short,
                isChecked: true,
              };
            } else {
              return {
                id: d.id,
                value: d.value,
                short: d.short,
                isChecked: false,
              };
            }
          }),
        });
        //If day is currently not checked and is going to be checked
        //Careful if 4 days are checked
      } else {
        if (selectedDays.length === 4) {
          days.forEach((d) => {
            fullDays.push(d.value);
          });
          this.setState({
            daysValue: "Weekdays",
            checkedDays: ["Weekdays"],
            fullDays: fullDays,
            days: MeetingTimes.days.map((d) => {
              return {
                id: d.id,
                value: d.value,
                short: d.short,
                isChecked: true,
              };
            }),
          });
        } else {
          selectedDays.push(day.value);
          MeetingTimes.days.forEach((d) => {
            let result = selectedDays.find((v) => v === d.value);
            if (result) {
              fullDays.push(d.value);
              valueArray.push(d.short);
            }
          });
          stringValue = valueArray.join(", ");
          this.setState({
            daysValue: stringValue,
            checkedDays: fullDays,
            fullDays: fullDays,
            days: MeetingTimes.days.map((d) => {
              let result = fullDays.find((v) => v === d.value);
              if (result) {
                return {
                  id: d.id,
                  value: d.value,
                  short: d.short,
                  isChecked: true,
                };
              } else {
                return {
                  id: d.id,
                  value: d.value,
                  short: d.short,
                  isChecked: false,
                };
              }
            }),
          });
        }
      }
    }
  }

  handleHourCheckboxClick(value) {
    let hours = [...this.state.hours];
    let checkedHours = [];
    let orderedCheckedHours = [];
    let valuesArray = [];
    let hoursValue = "";
    let hour = hours.find((v) => v.value === value);
    //Hour is checked => will get unchecked
    if (hour.isChecked === true) {
      hours.forEach((d) => {
        if (d.value !== value && d.isChecked === true) {
          checkedHours.push(d.value);
        }
      });

      MeetingTimes.hours.forEach((d) => {
        let result = checkedHours.find((v) => v === d.value);
        if (result) {
          orderedCheckedHours.push(d.value);
          valuesArray.push(d.value);
        }
      });

      hoursValue = valuesArray.join(", ");

      this.setState({
        hoursValue: hoursValue,
        checkedHours: orderedCheckedHours,
        hours: MeetingTimes.hours.map((d) => {
          let result = orderedCheckedHours.find((v) => v === d.value);
          if (result) {
            return {
              id: d.id,
              value: d.value,
              isChecked: true,
            };
          } else {
            return {
              id: d.id,
              value: d.value,
              isChecked: false,
            };
          }
        }),
      });

      //Hour is unchecked => will get checked
    } else {
      hours.forEach((d) => {
        if (d.value !== value && d.isChecked === true) {
          checkedHours.push(d.value);
        }
      });

      checkedHours.push(value);

      MeetingTimes.hours.forEach((d) => {
        let result = checkedHours.find((v) => v === d.value);
        if (result) {
          orderedCheckedHours.push(d.value);
          valuesArray.push(d.value);
        }
      });

      hoursValue = valuesArray.join(", ");

      this.setState({
        hoursValue: hoursValue,
        checkedHours: orderedCheckedHours,
        hours: MeetingTimes.hours.map((d) => {
          let result = orderedCheckedHours.find((v) => v === d.value);
          if (result) {
            return {
              id: d.id,
              value: d.value,
              isChecked: true,
            };
          } else {
            return {
              id: d.id,
              value: d.value,
              isChecked: false,
            };
          }
        }),
      });
    }
  }

  handleOnChange() {
    let key_index = this.props.key_index;
    let meeting_days = {
      weekdays: [...this.state.checkedDays],
      hours: [...this.state.checkedHours],
    };

    this.props.handleTimeSlotOnChange(key_index, meeting_days);
  }

  handleDayCheckboxOnChange() {
    this.handleOnChange();
  }

  handleHourCheckboxOnChange() {
    this.handleOnChange();
  }

  handleDeleteTimeSlot() {
    let index = this.props.key_index;
    this.props.handleDeleteTimeSlot(index);
  }

  render() {
    return (
      <div
        className="time-slot"
        style={{ zIndex: 10 - this.props.zIndexValue }}
      >
        <DayAndHourSelector
          daySelectorName="time-slot-selector-day"
          daysValue={this.state.daysValue}
          handleDayCheckboxClick={this.handleDayCheckboxClick} // func
          days={this.state.days}
          handleDayCheckboxOnChange={this.handleDayCheckboxOnChange} //func
          hourSelectorName="time-setter-selector-hour"
          hoursValue={this.state.hoursValue}
          handleHourCheckboxClick={this.handleHourCheckboxClick} //func
          hours={this.state.hours}
          handleHourCheckboxOnChange={this.handleHourCheckboxOnChange} //fucn
          zIndexValue={10 - this.props.zIndexValue}
        />
        <TimeSlotDeleteButton handleOnClick={this.handleDeleteTimeSlot} />
      </div>
    );
  }
}

export default TimeSlot;
